import React, { useEffect, useState } from 'react';
import Sidebar from '../Sidebar';
import { entityService } from '../../services/api';
import styles from './SidebarLayout.module.css';

/* Organisation banner. Fails quiet: a user with no entity, or a backend
   that predates the logo endpoint, simply gets no banner rather than an
   error across every signed-in page. */
const EntityBanner = () => {
  const [entity, setEntity] = useState(null);

  useEffect(() => {
    let cancelled = false;
    entityService
      .get()
      .then((data) => { if (!cancelled) setEntity(data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!entity) return null;

  const initials = (entity.entity_name || '')
    .split(/s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();

  return (
    <div className={styles.entityBanner}>
      <div className={styles.entityMark}>
        {entity.logo_url ? (
          <img src={entity.logo_url} alt={`${entity.entity_name} logo`} />
        ) : (
          <span>{initials || '—'}</span>
        )}
      </div>
      <span className={styles.entityName}>{entity.entity_name}</span>
    </div>
  );
};

const SidebarLayout = ({
  children,
  onUploadFile,
  onLoadData,
  onRefreshVisuals,
  refreshStatus,
  serverStatus,
  getRefreshButtonText,
  isUploading,
  selectedTier,
  onTierChange,
  hasSelectedFile = false,
  nestedNav = null,
}) => {
  return (
    <div className={styles.pageLayout}>
      <Sidebar
        onUploadFile={onUploadFile}
        onLoadData={onLoadData}
        onRefreshVisuals={onRefreshVisuals}
        refreshStatus={refreshStatus}
        serverStatus={serverStatus}
        getRefreshButtonText={getRefreshButtonText}
        isUploading={isUploading}
        selectedTier={selectedTier}
        onTierChange={onTierChange}
        hasSelectedFile={hasSelectedFile}
        nestedNav={nestedNav}
      />
      <div className={styles.mainContent} style={{ marginLeft: 'var(--sidebar-width, 256px)' }}>
        <EntityBanner />
        {children}
      </div>
    </div>
  );
};

export default SidebarLayout;
